/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/variants" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants,
  (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      campaignId,
      components,
    }: GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult> => {
    return fetch<GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult>(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/base_creatives/${campaignId}/variants`,
      "GET",
      { components },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult
);
